import { createGroupMutation } from './common/createGroupMutation';

export default createGroupMutation(
	'swap-group-mutation',
	(groups, [fromIndexes, toIndexes]) => {
		groups.swap(fromIndexes, toIndexes);
	},
 	{
		weight: 0.5,
		groupSize: 5,
		count: 2
	}
);



// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/mutations/providers/swapGroupMutation.jsx